import { inject, Injectable, OnDestroy } from '@angular/core';
import { MaterialSortProperty } from '@dave/types/dist/proto/erp/material';
import { from } from 'rxjs';
import { MaterialEntity } from '../entities/material.entity';
import { materialBackendFilter, MaterialDataService } from './material-data.service';
import { PaginatedItemsService, PaginatedItemsState, PaginationDetails } from './paginated-items-service';

export type materialBackendSort = MaterialSortProperty;
const initialState: PaginatedItemsState<MaterialEntity, materialBackendFilter, materialBackendSort> = {
    paginationDetails: {
        offset: 0,
        pageSize: 50,
    },
    pageContent: {
        items: [],
        length: null,
    },
    status: {
        isLoading: false,
        hasError: false,
        isCountLimitReached: false,
    },
};

@Injectable()
export class PaginatedMaterialService extends PaginatedItemsService<MaterialEntity, materialBackendFilter, materialBackendSort> {
    readonly vm$ = this.selectItems$;
    private readonly _materialDataService = inject(MaterialDataService);
    static id = 0;
    constructor() {
        PaginatedMaterialService.id++;
        console.log('PaginatedMaterialService id:' + PaginatedMaterialService.id);
        super(initialState);
    }
    protected getItems({ offset, pageSize, searchQuery, sortDirection, sortProperty, filterObject }: PaginationDetails<materialBackendFilter, materialBackendSort>) {
        console.log('getItems', offset, pageSize, searchQuery, sortDirection, sortProperty, filterObject);
        // todo add cache by paginationDetails, (global, with expirationDate)
        return from(this._materialDataService.getMaterials(offset, pageSize, searchQuery, sortDirection, sortProperty, filterObject));
    }
}
